<div class="card" style="border-color: #316ad8; margin: 10px;">
  <!-- HEADER AGREGADO -->
  <div class="card-header p-0">
    <div class="row p-0">
      <span class="badge badge-primary align-self-start badge-color">
        Agendamiento
      </span>
      <app-popover *ngIf="options_bool" style="color: #0e0087;">

        <!-- <a data-toggle="modal" [attr.data-target]="'#cancelarAppoModal' + data.id_consulta" click="cancelarHora()">
          <p>Anular consulta</p>
        </a> -->
        <a (click)="abrirModal('cancelarPendiente')">
          <p>Anular consulta</p>
        </a>


      </app-popover>
    </div>
  </div>

  <div class="card-block" style="padding: 0% 5% 3% !important; width: 100%;">
    <div class="m-0 p-0 first-line">
      <app-profile-img [img]="data.att_path" [doctorName]="data.n_doctor" [doctorLastName]="data.a_doctor">
      </app-profile-img>
      <div class="row">
        <div class="col-md-12 ml-3 align-self-center">
          <p class="card-text m-0 p-0 appt-date" style="font-weight: 700 !important; color: #171994;">{{data.hoy ? 'Hoy' : ''}} {{ data.dia }} de {{ data.mes }} a las {{ data.hora }} horas.</p>
          <!-- <p class="card-text m-0 p-0 appt-date" style="font-weight: 700; color: #171994;">a las {{ data.hora }} horas.</p> -->
        </div>

        <div class="col-md-12 ml-3 align-self-center">
          <p class="card-text m-0 p-0 appt-date" style="font-weight: 700 !important; color: #171994;">Monto pendiente:
          </p>
          <p class="card-text m-0 p-0 doc-data" style="font-weight: 700 !important;">${{ data.cha_final_value |
            puntoMiles }}</p>
        </div>

      </div>
    </div>

    <p class="card-text pt-3 mr-5 doc-data">
      {{ data.nombre_doctor }} - {{ data.spe_name }}
    </p>

    <div class="col-12" style="    margin-top: auto;">
      <div class="row p-0">
        <div class="col-6 p-0" style=" display: flex; justify-content: flex-start;">
          <button type="button" class="btn btn-primary mr-auto" style="float: right;" (click)="finishPending()">
            Finalizar reserva
          </button>
        </div>
        <div class="col-6 p-0" style=" display: flex; align-items: center; justify-content: flex-end;">
          <p class="card-text flag-helper" style="text-align: end; color: red">Pendiente de pago</p>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- MODAL CONFIRMACIÓN PRINCIPAL -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'cancelarPendiente'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Deseas anular tu reserva pendiente?</h2>
    <p class="modal-reason">
      Al hacerlo, perderás tu reserva actual y deberás generar una nueva si deseas reagendar.
    </p>
    <p class="modal-reason2">Selecciona el motivo por el cual estás anulando:</p>

    <form [formGroup]="anularReservaForm">
      <div class="form-group">
        <select class="form-control" formControlName="motivo">
          <option value="" disabled selected>Selecciona un motivo</option>
          <option *ngFor="let razon of cancelReason" [value]="razon.id_reason">
            {{ razon.reason_name }}
          </option>
        </select>
      </div>
    </form>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()">
          <p class="m-0" style="font-weight: 600;">Volver</p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" [disabled]="anularReservaForm.invalid"
          (click)="mostrarModalConfirmacion()">
          <p class="m-0" style="font-weight: 600;">Aceptar</p>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- SEGUNDO MODAL DE CONFIRMACIÓN FINAL -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmacionFinalPendiente'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">Confirmación de anulación</h2>
    <p class="modal-reason">
      Al confirmar esta acción, no se realizará devolución del pago ni se reembolsará lo asociado a tu convenio.
    </p>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()"
          [disabled]="isCanceling">
          <p class="m-0" style="font-weight: 600;">Cancelar</p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" (click)="anularReservaConfirmada()"
          [disabled]="isCanceling">
          <p class="m-0" style="font-weight: 600;">
            {{ isCanceling ? 'Anulando...' : 'Aceptar' }}
          </p>
        </button>
      </div>
    </div>
  </div>
</div>